import React from 'react';
import { FileTextIcon, CpuIcon, FileCheck2Icon, ArrowRightIcon } from 'lucide-react';
const nodes = [{
  icon: FileTextIcon,
  label: 'Prompt',
  sub: 'your instruction + your facts',
  tone: 'bg-white text-plum border-grape/20',
  iconTone: 'bg-lilac-soft text-grape'
}, {
  icon: CpuIcon,
  label: 'AI',
  sub: 'ChatGPT · Claude · Gemini',
  tone: 'bg-plum text-white border-plum',
  iconTone: 'bg-grape text-white'
}, {
  icon: FileCheck2Icon,
  label: 'Result',
  sub: 'draft ready for your review',
  tone: 'bg-white text-plum border-blush/30',
  iconTone: 'bg-blush-soft text-blush'
}];
export function PromptFlow() {
  return <div className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-center" aria-label="How a prompt works" data-id="element-230" data-mp="2zkifg5pg58ik">
      {nodes.map((n, i) => <React.Fragment key={n.label} data-id="element-231" data-mp="156hgzlxt6nj0" data-mpi={i}>
          <div className={`flex items-center gap-3 rounded-2xl border px-4 py-3 sm:w-52 ${n.tone}`} data-id="element-232" data-mp="157it7tqk9g2b">
            <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${n.iconTone}`} data-id="element-233" data-mp="1a5km16dsgtqz">
              <n.icon className="h-5 w-5" data-id="element-234" data-mp="1f11m0wzvbiji" />
            </span>
            <div className="min-w-0" data-id="element-235" data-mp="1a7yzh8tid9ct">
              <p className="font-display text-base font-black" data-id="element-236" data-mp="1a6xb62nheqd5">{n.label}</p>
              <p className="truncate text-xs opacity-70" data-id="element-237" data-mp="15aoxyusuh78m">{n.sub}</p>
            </div>
          </div>
          {i < nodes.length - 1 && <ArrowRightIcon className="mx-auto h-5 w-5 rotate-90 text-grape sm:mx-0 sm:rotate-0" aria-hidden="true" data-id="element-238" data-mp="108rblrp5dwbg" />}
        </React.Fragment>)}
    </div>;
}